export default __webpack_public_path__ + "static/media/gray_cat.012c71fa.png";